export const tooltips: { [key: string]: string} = {
    email: "This is the email address you used to get your original quote.",
};
